import React, { useState } from 'react';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useCollection } from '../../hooks/useCollection';
import { slugify } from '../../utils/slugify';
import ImageUploader from './ImageUploader';
import BloqueEditor from './BloqueEditor';

const EMPTY = {
  titulo: '', descripcionCorta: '', descripcionLarga: [],
  fecha: '', hora: '', lugar: '', imagen: '', link: '', url: '', orden: 0,
};

const AdminEventos = () => {
  const { docs, loading } = useCollection('eventos');
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [guardando, setGuardando] = useState(false);

  const abrirNuevo = () => { setForm(EMPTY); setEditando('nuevo'); };
  const abrirEdicion = (e) => { setForm({ ...e }); setEditando(e.slug); };
  const cerrar = () => setEditando(null);

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    const slug = editando === 'nuevo' ? slugify(form.titulo) : editando;
    await setDoc(doc(db, 'eventos', slug), { ...form, slug });
    setGuardando(false);
    cerrar();
  };

  const eliminar = async (slug) => {
    if (!window.confirm('¿Eliminar este evento?')) return;
    await deleteDoc(doc(db, 'eventos', slug));
  };

  if (loading) return <p>Cargando...</p>;

  if (editando) return (
    <form className="admin-form" onSubmit={guardar}>
      <h2>{editando === 'nuevo' ? 'Nuevo evento' : 'Editar evento'}</h2>

      <label>Título *</label>
      <input value={form.titulo} onChange={e => set('titulo', e.target.value)} required />

      <label>Descripción corta *</label>
      <textarea value={form.descripcionCorta} onChange={e => set('descripcionCorta', e.target.value)} rows={3} required />

      <label>Descripción larga (bloques)</label>
      <BloqueEditor bloques={form.descripcionLarga} onChange={val => set('descripcionLarga', val)} />

      <label>Fecha</label>
      <input value={form.fecha} onChange={e => set('fecha', e.target.value)} placeholder="ej: 12 de marzo de 2026" />

      <label>Hora</label>
      <input value={form.hora} onChange={e => set('hora', e.target.value)} placeholder="ej: 19:30 hs" />

      <label>Lugar</label>
      <input value={form.lugar} onChange={e => set('lugar', e.target.value)} />

      <label>Imagen principal</label>
      <ImageUploader folder="eventos" currentUrl={form.imagen} onUpload={url => set('imagen', url)} />
      <input value={form.imagen} onChange={e => set('imagen', e.target.value)} placeholder="URL o ruta de la imagen" />

      <label>Etiqueta del botón (ej: INSCRIPCION ONLINE)</label>
      <input value={form.link} onChange={e => set('link', e.target.value)} />

      <label>URL del botón</label>
      <input value={form.url} onChange={e => set('url', e.target.value)} type="url" />

      <label>Orden de aparición (menor = primero)</label>
      <input type="number" value={form.orden} onChange={e => set('orden', Number(e.target.value))} />

      <div className="admin-form-actions">
        <button type="submit" className="admin-btn admin-btn-primary" disabled={guardando}>
          {guardando ? 'Guardando...' : 'Guardar'}
        </button>
        <button type="button" className="admin-btn" onClick={cerrar}>Cancelar</button>
      </div>
    </form>
  );

  return (
    <div>
      <div className="admin-section-header">
        <h2>Eventos</h2>
        <button className="admin-btn admin-btn-primary" onClick={abrirNuevo}>+ Nuevo evento</button>
      </div>
      <table className="admin-table">
        <thead>
          <tr><th>Orden</th><th>Título</th><th>Fecha</th><th></th></tr>
        </thead>
        <tbody>
          {docs.map(e => (
            <tr key={e.id}>
              <td>{e.orden}</td>
              <td>{e.titulo}</td>
              <td>{e.fecha}</td>
              <td className="admin-table-actions">
                <button className="admin-btn" onClick={() => abrirEdicion(e)}>Editar</button>
                <button className="admin-btn admin-btn-danger" onClick={() => eliminar(e.slug)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminEventos;
